/* eslint-disable import/prefer-default-export */

import { SEG_CMP } from 'src/store/ActionTypes';

export const fetchSegments = (segmentIds, clusterIds) => ({
  type: SEG_CMP.FETCH_SEGMENTS,
  payload: {
    segmentIds,
    clusterIds,
  },
});

export const editSegment = (id, payload) => ({
  type: SEG_CMP.EDIT_SEGMENT,
  payload: {
    id,
    payload,
  },
});
